import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';

const RoleBasedRoute = ({ children, allowedRoles, redirectTo }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();


  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user || !user.role) {
    return <Navigate to="/farmer-dashboard" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const userRole = user.role.toLowerCase();
    let defaultRedirect = '/farmer-dashboard';
    if (userRole === 'expert') {
      defaultRedirect = '/expert-dashboard';
    } else if (userRole === 'retailer') {
      defaultRedirect = '/retailer-dashboard';
    } else if (userRole === 'farmer') {
      defaultRedirect = '/farmer-dashboard';
    }
    
    return <Navigate to={redirectTo || defaultRedirect} replace />;
  }

  return children;
};

// Helper component for dashboard redirection based on role
export const DashboardRedirect = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <Loader />;
  }
  
  if (!user || !user.role) {
    return <Navigate to="/farmer-dashboard" replace />;
  }
  
  const userRole = user.role.toLowerCase();
  
  switch (userRole) {
    case 'expert':
      return <Navigate to="/expert-dashboard" replace />;
    case 'retailer':
      return <Navigate to="/retailer-dashboard" replace />;
    case 'farmer':
      return <Navigate to="/farmer-dashboard" replace />;
    default:
      return <Navigate to="/farmer-dashboard" replace />;
  }
};

export default RoleBasedRoute;
